module.exports = __webpack_public_path__ + "static/media/WBD-FINAL_page-0001.3150b8e8.jpg";